import * as moment from 'moment/moment';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { Subscription } from 'rxjs';
import { ReportsHelpbuttonService } from 'src/app/services/helpbutton-services/reports-helpbutton-service/reports-helpbutton.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-helpbutton-reports-filter-assistances-card',
  templateUrl: './helpbutton-reports-filter-assistances-card.component.html',
  styleUrls: ['./helpbutton-reports-filter-assistances-card.component.scss']
})
export class HelpbuttonReportsFilterAssistancesCardComponent implements OnInit, OnDestroy {

  show: boolean;
  showAdvanced: boolean;
  centerList;
  statusList;
  dateFromPlaceholder: string;
  dateToPlaceholder: string;
  timeFromPlaceholder: string;
  timeToPlaceholder: string;
  searchReportsSubscription: Subscription;
  refreshAssistancesList: Subscription;
  basicDataForm = new FormGroup({
    dateFrom: new FormControl(''),
    dateTo: new FormControl(''),
    timeFrom: new FormControl(''),
    timeTo: new FormControl(''),
    selectedCentersList: new FormControl(),
    selectedStatusList: new FormControl(),
    checkboxBad: new FormControl(false),
    checkboxNeutral: new FormControl(false),
    checkboxGood: new FormControl(false),
  });
  constructor(private userStorageService: UserStorageService,
              private reportsService: ReportsHelpbuttonService,
              private snackbarService: SnackBarService) {
    this.show = false;
    this.dateFromPlaceholder = 'from';
    this.dateToPlaceholder = 'to';
    this.timeFromPlaceholder = 'from';
    this.timeToPlaceholder = 'to';
  }

  ngOnInit() {
    this.centerList = this.userStorageService.getCenterList();
    this.statusList = [{ internalId : 'CANCELLED'}, { internalId : 'CANCELLED_AUTOMATICALLY'}, { internalId : 'CLOSED'}, { internalId : 'IN-ASSISTANCE' }];
    if (this.reportsService.getRememberedForm().form) {
      this.basicDataForm = this.reportsService.getRememberedForm().form;
      this.showAdvanced = this.reportsService.getRememberedForm().showAdvanced;
      this.search(); //Buscar otra vez? y si recuperamos los datos anteriores ya con su sort?
    }
  }

  public showFilter() {
    this.show = !this.show;
  }

  public showAdvancedFilter() {
    this.showAdvanced = !this.showAdvanced;
  }

  public search() {
    this.show = false;
    const rateArray = new Array<string>();
    const dateFrom = this.basicDataForm.get('dateFrom').value.valueOf();
    const dateTo = this.basicDataForm.get('dateTo').value.valueOf();
    const timeFrom = (moment(this.basicDataForm.get('timeFrom').value, 'hh:mm').hour() * 3600000) + (moment(this.basicDataForm.get('timeFrom').value, 'hh:mm').minutes() * 60000);
    const timeTo = (moment(this.basicDataForm.get('timeTo').value, 'hh:mm').hour() * 3600000) + (moment(this.basicDataForm.get('timeTo').value, 'hh:mm').minutes() * 60000);
    const from = timeFrom ? dateFrom + timeFrom : dateFrom;
    const to = timeTo ? dateTo + timeTo : dateTo;
    if (this.basicDataForm.get('checkboxBad').value) {
      rateArray.push('BAD');
    } if (this.basicDataForm.get('checkboxNeutral').value) {
      rateArray.push('NEUTRAL');
    } if (this.basicDataForm.get('checkboxGood').value) {
      rateArray.push('GOOD');
    }
    this.reportsService.rememberForm(this.basicDataForm, this.showAdvanced);
    this.searchReportsSubscription = this.reportsService.filterAssistanceList(this.mapCentersIds(this.basicDataForm.get('selectedCentersList').value), from, to, rateArray, this.mapStatusIds(this.basicDataForm.get('selectedStatusList').value)).subscribe(
      (res) => {
        if (res) {
          const assistances = new Array<Object>();
          res['data']['assistanceList'].forEach(
            (item) => {
              // No voy a modelar assistance porque contiene dtos que no cuadran con el modelo, trabajo con el json directamente
              const assistance = new Object();
              Object.assign(assistance, item);
              assistances.push(assistance);
            }
          );
          this.reportsService.refreshAssistancesList(res);
          this.reportsService.refreshFormattedAssistancesList(res);
        }
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public centersOutputEventReceiver(centers) {
    const aux = new Array();
    for (const c of centers) {
      aux.push(c[1]._data);
    }
    this.basicDataForm.get('selectedCentersList').setValue(aux);
  }

  public statusOutputEventReceiver(statusList) {
    const aux = new Array();
    for (const s of statusList) {
      aux.push(s[1]._data);
    }
    this.basicDataForm.get('selectedStatusList').setValue(aux);
  }

  public reset() {
    this.basicDataForm.patchValue({
      dateFrom: '',
      dateTo: '',
      timeFrom: '',
      timeTo: '',
      checkboxBad: '',
      checkboxNeutral: '',
      checkboxGood: ''
    });
  }

  public mapCentersIds(centers) {
    if (centers && (centers.length > 0)) {
      return centers.map((center) => center.InternalId);
    }
  }

  public mapStatusIds(statusList) {
    if (statusList && (statusList.length > 0)) {
      return statusList.map((status) => status.internalId);
    }
  }

  ngOnDestroy() {
    if (this.searchReportsSubscription) { this.searchReportsSubscription.unsubscribe(); }
  }

}
